<template>
  <div class="img-box b1" :class="clickView && 'pointer'" :style="style" @click="view">
    <slot></slot>
    <XModal v-if="clickView" ref="viewModal" title="图片查看" width="80%" dialogClass="center" :okBtn="false">
      <slot></slot>
    </XModal>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      default: 100
    },
    clickView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      
    };
  },
  computed:{
    style(){
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    }
  },
  mounted(){
  },
  methods:{
    view(){
      if(!this.clickView) return
      this.$refs.viewModal.open()
    }
  }
};
</script>
<style lang="less" scoped>
.img-box{
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  * {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
<style lang="less">
.img-box{
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
